import React from 'react';
import {
    Field,
    Text
} from '@fluentui/react-components';
import {
    CloudArrowUp24Regular
} from '@fluentui/react-icons';
import { TFunction } from 'i18next';

import './FileSelectionSection.css';

interface FileSelectionSectionProps {
    formValidation: { file: boolean };
    submittedForm: boolean;
    isUploading: boolean;
    handleFileSelection: (event: React.ChangeEvent<HTMLInputElement>) => void;
    t: TFunction;
}

export const FileSelectionSection: React.FC<FileSelectionSectionProps> = ({ 
    formValidation, 
    submittedForm, 
    isUploading, 
    handleFileSelection, 
    t 
}) => {
    const [isDragActive, setIsDragActive] = React.useState(false);
    const inputRef = React.useRef<HTMLInputElement>(null);

    // Handler para drop
    const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
        event.preventDefault();
        event.stopPropagation();
        setIsDragActive(false);
        if (event.dataTransfer.files && event.dataTransfer.files.length > 0) {
            // Simula el evento de input para reutilizar handleFileSelection
            const fileInputEvent = {
                ...event,
                target: { files: event.dataTransfer.files }
            } as unknown as React.ChangeEvent<HTMLInputElement>;
            handleFileSelection(fileInputEvent);
            event.dataTransfer.clearData();
        }
    };

    // Handler para drag over
    const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
        event.preventDefault();
        event.stopPropagation();
        setIsDragActive(true);
    };

    // Handler para drag leave
    const handleDragLeave = (event: React.DragEvent<HTMLDivElement>) => {
        event.preventDefault();
        event.stopPropagation();
        setIsDragActive(false);
    };

    // Handler para click en el área
    const handleAreaClick = () => {
        if (inputRef.current && !isUploading) {
            inputRef.current.click();
        }
    };

    return (
        <Field
            label={t('fileUpload.selectFiles')}
            required
            validationState={!formValidation.file && submittedForm ? 'error' : 'none'}
            validationMessage={!formValidation.file && submittedForm ? t('fileUpload.fileRequired') : ''}
        >
            <div
                className={`file-upload-area${isDragActive ? ' drag-active' : ''}`}
                onDrop={handleDrop}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onClick={handleAreaClick}
                style={{ cursor: isUploading ? 'not-allowed' : 'pointer', border: isDragActive ? '2px dashed #0078d4' : undefined }}
            >
                <input
                    type="file"
                    multiple
                    onChange={handleFileSelection}
                    disabled={isUploading}
                    className="file-input"
                    id="file-upload-input"
                    ref={inputRef}
                    style={{ display: 'none' }}
                />
                <label htmlFor="file-upload-input" className="file-upload-label" style={{ pointerEvents: 'none' }}>
                    <CloudArrowUp24Regular />
                    <Text>{t('fileUpload.selectFilesToUpload')}</Text>
                </label>
                {isDragActive && (
                    <div className="file-upload-drag-overlay">
                        <Text>{t('fileUpload.dropFilesHere') || 'Suelta los archivos aquí...'}</Text>
                    </div>
                )}
            </div>
        </Field>
    );
};
